import { Directive, forwardRef, Input } from "@angular/core";
import { NG_ASYNC_VALIDATORS, Validator, AbstractControl } from "@angular/forms";
import { Observable } from "rxjs/Rx";

import { UserProfileService } from './user-profile.service';


import 'rxjs/add/operator/map';

@Directive({
    selector: "[passwordHistoryValidator][ngModel] [passwordHistoryValidator][userId] [passwordHistoryValidator][userPasswSalt]",
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => PasswordHistoryValidator), multi: true
        }
    ]
})

export class PasswordHistoryValidator implements Validator {
    @Input('userId') public id;
    @Input('userPasswSalt') public salt;
    constructor(
        private _usersService: UserProfileService) {
    }

    public validate(c: AbstractControl): Promise<{ [key: string]: any }> | Observable<{ [key: string]: any }> {
        // No need to request server when:
        //   - field is pristine (will be changed before submitting the form to server)
        //   - user id is not defined (password history can not be retrieved = password history is empty)
        return (c.dirty && this.id != '') ?
            this.validatePasswordHistory(c.value, this.id, this.salt) :
            Observable.of([]);
    }

    public validatePasswordHistory(password: string, userId: number, salt: string) {
        return Observable.timer(300).switchMap(() => {
            return this._usersService.checkUserPasswordAvailability(password, userId, salt);
        });
    }
}

@Directive({
    selector: "[passwordHistoryValidatorWithToken][ngModel] [passwordHistoryValidatorWithToken][userToken] [passwordHistoryValidatorWithToken][userPasswSalt]",
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => PasswordHistoryValidatorWithToken), multi: true
        }
    ]
})

export class PasswordHistoryValidatorWithToken implements Validator {
    @Input('userToken') public token;
    @Input('userPasswSalt') public salt;
    constructor(
        private _usersService: UserProfileService) {
    }

    public validate(c: AbstractControl): Promise<{ [key: string]: any }> | Observable<{ [key: string]: any }> {
        return c.dirty ? this.validatePasswordHistory(c.value, this.token, this.salt) : Observable.of([]);
    }

    public validatePasswordHistory(password: string, token: string, salt: string) {
        return Observable.timer(300).switchMap(() => {
            return this._usersService.checkUserPasswordAvailabilityWithToken(password, token, salt);
        });
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/user-profile/password-history.validator.directive.ts